/**
 * Skeleton - Loading Placeholder Component
 *
 * Animated placeholder for content that's loading.
 * Renders as Box with pulse animation.
 *
 * @example
 * <Skeleton className="h-4 w-20" />
 * <Skeleton className="h-32 w-full rounded-lg" />
 */
import { forwardRef } from "react";
import { Box } from "@/shared/ui/base";
import { cn } from "@/shared/lib/utils/cn";
import type { BaseComponentProps } from "@/shared/ui/base";

export type SkeletonProps = BaseComponentProps;

/**
 * Skeleton component
 * Renders as a Box with animated background
 */
export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        className={cn("bg-gray-200 rounded animate-pulse", className)}
        {...props}
      />
    );
  },
);

Skeleton.displayName = "Skeleton";
